import styled from '@emotion/styled';

const TableHeader = styled.div``;

const HeadersRow = styled.div`
  display: flex;
  justify-content: stretch;
  font-weight: bold;
  width: 100%;
`;

// TODO: Not used
const HeaderContents = styled.div``;

export { HeaderContents, HeadersRow, TableHeader };
